import { EstateListingDetailsQueryActions } from '@contexts/Estate';
import { createContext, useContext } from 'react';
import { GqlListingDetailsQueryActions } from '../graphql/adapters/gql-listing-details-query.actions';

type EstateActionsContextT = {
  listingDetailsQueryActions: EstateListingDetailsQueryActions;
};

export const estateDefaultValue: EstateActionsContextT = {
  listingDetailsQueryActions: GqlListingDetailsQueryActions,
};

export const EstateActionsContext = createContext<EstateActionsContextT>(estateDefaultValue);

export const useEstateActions = (): EstateActionsContextT => useContext(EstateActionsContext);
